import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import { instance } from "Actions/AxiosInstance";
import empty from "Assets/Svg/recruiter.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import CallOutNew from "Component/Headers/callOutNew";
import { CheckActionPermission } from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import DrawerHeader from "Component/Headers/drawerHeader";
import PageHeader from "Component/Headers/pageHeader";
import { ErrorMessages } from "Constants";
import headersList from "Constants/headersList";
import { Helmet } from "react-helmet";
import loader from "Assets/Gif/loader.gif";
import {
  setSaveProgress,
  removeSaveProgress,
} from "Actions/SaveProgressAction";
import CustomLoader from "Component/CustomLoader";

import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import settingsIcon from "Assets/newicons/user-interface/setting-option/outline/setting-option-outline-16px.svg";
import Select from "react-select";

let shouldCallAPI = true;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      employeelist: [],
      selectedemployee: null,
      permissions: { editable: true, readonly: true },
      listdata: [],
      postData: null,
      drawerOpen: false,
      emailNotificationDrawerOpen:false,
      pageloading: true,
      selectedEmployeeIds: "",
      ErEmployees: false,
      headers: [
        {
          key: "fullname",
          name: "Employee name",
          style: { textAlign: "left" },
          type: TDTypeConsts.PROFILE,
        },
        {
          key: "addeddate",
          name: "Added date",
          style: { textAlign: "center" },
          type: TDTypeConsts.CREATED_DATE,
        },

        {
          key: "",
          name: "",
          type: TDTypeConsts.DELETE_WITHOUT_HEADER,
        },
      ],
    };

    this.getallrecruiter = this.getallrecruiter.bind(this);
    this.renderList = this.renderList.bind(this);

    this.onSave = this.onSave.bind(this);

    this.onDelete = this.onDelete.bind(this);

    this.updatePostData = this.updatePostData.bind(this);
    this.recruiterDrawer = this.recruiterDrawer.bind(this);
    this.emailNotificationDrawer = this.emailNotificationDrawer.bind(this);
    this.onSaveEmailNotifyIds = this.onSaveEmailNotifyIds.bind(this);
  }

  handleScroll1 = () => {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (shouldCallAPI) {
        if (this.state.fullcount > this.state.offset) {
          shouldCallAPI = false;
          this.setState(
            {
              offset: this.state.offset + 10,
            },
            () => this.callAllLeavePolicy(),
          );
          setTimeout(() => {
            shouldCallAPI = true;
          }, 5000);
        } else {
          this.setState({
            message: "no data",
          });
        }
      }
    }
  };

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("recruiters");

    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getallrecruiter();
        if (!this.state.permissions.editable) {
          const index =
            this.state.headers &&
            this.state.headers.findIndex(
              (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
            );
          if (index != -1) {
            this.state.headers && this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  UpdateEmployeeIds(selectedItems) {
    const employeeIds = [];
    for (const item of selectedItems) {
      employeeIds.push(item.displayvalue);
    }
    this.setState({
      employeeIds,
      selectedEmployeeIds: selectedItems,
      ErEmployees: false,
    });
  }

  onSaveEmailNotifyIds() {
    let { selectedEmployeeIds } = { ...this.state };
    let postData = { "employeeids" : selectedEmployeeIds.map((x) => x.displayvalue).join(",") || ''}
    instance
      .post("recruit/createreplytoemail", postData )
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0000, {
          variant: "success",
        });
        this.props.removeSaveProgress();
          this.setState(
            {
              emailNotificationDrawerOpen: false,
              postData: null,
              selectedemployee: null,
            },
            () => {
              this.getallrecruiter();
            },
          );
      })
      .catch((error) => {
        this.props.removeSaveProgress();
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getallrecruiter() {
    this.setState({isLoading:true}, () => {
      instance
      .get(`recruit/getallrecruiter/true`)
      .then((resp) => {
        const allRecruiters = resp.data.result[0].recruiter;
        this.setState({
          listdata: allRecruiters.filter((recruiter) => recruiter.isactive),
          pageloading: false,
          isLoading:false
        });
      })
      .catch((error) => {
        this.setState({ pageloading: false, isLoading: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    })
   
  }

  updatePostData(key, value) {
    this.setState({
      selectedemployee: value,
      postData: { employeeid: value },
    });
  }

  onSave() {
    const { postData } = this.state;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    if (!postData) {
      this.props.enqueueSnackbar(`Please select a recruiter`, {
        variant: "error",
      });
      return;
    }
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      instance
        .post(`/recruit/createrecruiter`, postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.removeSaveProgress();
          this.setState(
            {
              drawerOpen: false,
              postData: null,
              selectedemployee: null,
            },
            () => {
              this.getallrecruiter();
            },
          );
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  onDelete(row) {
    const postData = {
      recruiterid: row.recruiterid,
      isactive: false,
    };

    if (this.state.listdata.length < 2) {
      this.props.enqueueSnackbar(
        "Can not delete, atleast one recruiter require.",
        {
          variant: "error",
        },
      );
    } else {
      instance
        .post(`recruit/activeinactiverecruiter`, postData)
        .then(() => {
          this.props.enqueueSnackbar("Deleted successfully", {
            variant: "success",
          });
          this.getallrecruiter();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  recruiterDrawer() {
    const data = { statusid: 1 };
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {
        this.setState({
          drawerOpen: true,
          employeelist: result.data.result,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  emailNotificationDrawer() {
    const data = { statusid: 1 };
    const { listdata } = this.state;
    instance
      .post(`subscription/getemployeelist`, data)
      .then((result) => {

        instance
          .get(`recruit/getallreplytoemail`)
          .then((resultreplyto) => {
            let selectedEmp = [];
            if( resultreplyto.data.result.length == 0 ){
              listdata && listdata.forEach((y) => {
                selectedEmp.push(
                ...result.data.result.filter((x) => x.displayvalue == y.employeeid ));
              })
            }else{
              let list = resultreplyto.data.result[0] && resultreplyto.data.result[0].employeeids.split(",");
              list && list.forEach((y) => {
                selectedEmp.push(
                ...result.data.result.filter((x) => x.displayvalue == y ));
              });

              // listdata && listdata.forEach((y) => {
              //   selectedEmp.push(
              //   ...result.data.result.filter((x) => x.displayvalue == y.employeeid ));
              // })

            }

            this.setState({
              selectedEmployeeIds: selectedEmp,
            });
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response ? error.response.data.error.message : error.message,
              { variant: "error" },
            );
          });

          this.setState({
            emailNotificationDrawerOpen: true,
            employeelist: result.data.result,
          });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    
  }

  renderList() {
    const {
      selectedEmployees
    } = this.state;
    const showempselection = this.state.listdata;

    return (
      <div className="content-outer-wrapper">
        <Helmet>
          <title>{headersList.Config.ATS.Recruiters.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <PageHeader header="Recruiters" />
            {this.state.permissions.editable && (
              <CallOutNew
                classnames="bg-light-blue width100"
                // header={`Your company has purchased 10 recruiters seats. You can add 9 more recruiters`}
                header={`You have added ${
                  this.state.listdata && this.state.listdata.length
                } recruiter, you can add more using the "Add Recruiter" button`}
                emoji="💡"
                textcolor="#1e8ced"
              />
            )}
            <div
              className="display-flex margin-bottom-16 margin-top-24"
              style={{ justifyContent: "space-between" }}
            >
              <p className="normal-dark">Recruiters list</p>
              {this.state.permissions.editable && (
                <div style={{
                  //padding: "8px 16px",
                  //marginRight: 10,
                  width: "33%",
                  display: "flex",
                  height: 24,
                  cursor: "pointer",
                  marginBottom:8
                }}>
                  <span
                        className="rounded-rectangle-div margin-right-16"
                        style={{
                          padding: "8px 16px",
                          marginRight: 8,
                          width: 157,
                          display: "flex",
                          height: 24,
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                        onClick={this.emailNotificationDrawer}
                      >
                        <img className="margin-right-16" src={settingsIcon}></img>
                        <p className="small-dark-secondary">
                          Email notifications
                        </p>
                  </span>
                  <Button
                    variant="contained"
                    className="btn btn-primary-md-blue"
                    color="primary"
                    onClick={this.recruiterDrawer}
                  >
                    Add recruiter
                  </Button>
                </div>
              )}
            </div>
            <div>
              {this.state.pageloading ? (
                <img className="loader" src={loader} />
              ) : (
                <div>
                  {this.state.isLoading ? 
                   <CustomLoader/>
              :  <div>
                  {this.state.listdata && this.state.listdata.length > 0 ? (
                    <div>
                      <List
                        showOnlyList
                        list={this.state.listdata}
                        permissions={this.state.permissions}
                        headers={this.state.headers}
                        onCreate={this.onSave}
                        onEdit={this.onEdit}
                        onDelete={this.onDelete}
                        onStateStatusChange={this.onStateStatusChange}
                      />
                    </div>
                  ) : (
                    <div className="position-rel">
                      <DefaultComp
                        heading="You are yet to add an employee as recruiter"
                        subheading="Get started by adding your first recruiter!"
                        imageSrc={empty}
                      />
                    </div>
                  )}
                </div>
                }
                </div>
              )}
            </div>
          {/* Add recruiter drawer */}
            <Drawer
              anchor="right"
              open={this.state.drawerOpen}
              onClose={() => this.setState({ drawerOpen: false })}
              classes={{
                paper: "width30 planner-drawer padding15",
              }}
            >
              <DrawerHeader
                header="Add recruiter"
                isbackarrow={false}
                closeDrawer={() => this.setState({ drawerOpen: false })}
              />

              <div className="padding-bottom-16 thin-scroll">
                <p className="normal-dark-secondary margin-bottom-4">
                  Select employee
                </p>
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.selectedemployee || null,
                    placeholder: "",
                    label: "",
                    options: this.state.employeelist || [],
                  })}
                  onChange={(id) => this.updatePostData("employeeid", id)}
                />
                {this.state.permissions.editable && (
                  <div>
                    <Button
                      variant="contained"
                      className="btn btn-primary-md-blue"
                      color="primary"
                      onClick={this.onSave}
                    >
                      Save
                    </Button>
                  </div>
                )}
              </div>
            </Drawer>

            {/* Email notification drawer */}
            <Drawer
              anchor="right"
              open={this.state.emailNotificationDrawerOpen}
              onClose={() => this.setState({ emailNotificationDrawerOpen: false })}
              classes={{
                paper: "width30 planner-drawer padding15",
              }}
            >
              <DrawerHeader
                header="Email notifications"
                isbackarrow={false}
                closeDrawer={() => this.setState({ emailNotificationDrawerOpen: false })}
              />

              <div className="padding-bottom-16 thin-scroll margin-top-16">
                <p className="normal-dark-secondary">
                  Who should we include in reply-to when invitation & reminder emails are sent to candidates
                </p>

                <div className="width100 margin-top-16">
                  <Select
                    className="selectsearch"
                    onChange={this.UpdateEmployeeIds.bind(this)}
                    isMulti
                    options={this.state.employeelist}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedEmployeeIds || null}
                    placeholder="Select Employee"
                  />
                  <div>
                    {this.state.ErEmployees ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErEmployees"
                          defaultMessage="Please select employee"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.selectedemployee || null,
                    placeholder: "",
                    label: "",
                    options: this.state.employeelist || [],
                  })}
                  onChange={(id) => this.updatePostData("employeeid", id)}
                /> */}
                {this.state.permissions.editable && (
                  <div className="margin-top-16">
                    <Button
                      variant="contained"
                      className="btn btn-primary-md-blue"
                      color="primary"
                      onClick={this.onSaveEmailNotifyIds}
                    >
                      Save
                    </Button>
                  </div>
                )}
              </div>
            </Drawer>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path={`${match.path}`} render={this.renderList} />

          <Redirect from={`${match.path}`} to={`${match.path}`} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setSaveProgress, removeSaveProgress }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);
